import React from 'react'

export const withDragAndDrop = ( WrappedComponent ) => {
  return class extends React.Component {
    constructor ( props ) {
      super( props )
  
      this.draggedElement = null
      this.droppedElement = null
      this.dragData = null
      this.dropData = null
  
      this.onStartDrag = this.onStartDrag.bind( this )
      this.onDragOver = this.onDragOver.bind( this )
      this.onDragEnter = this.onDragEnter.bind( this )
      this.onDragLeave = this.onDragLeave.bind( this )
      this.onDragEnd = this.onDragEnd.bind( this )
      this.getDragData = this.getDragData.bind( this )
    }

    /**
   * On thumbnail drag start
   * @param {Event} e 
   */
    onStartDrag ( e, dragData ) {
      this.dragData = dragData
      this.draggedElement = e.currentTarget
      setTimeout( () =>  this.draggedElement.classList.add( 'drag-hide' ) )
      e.dataTransfer.effectAllowed = 'move'
    }


    /**
   * on Drag Enter
   * @param {Event} e 
   */
    onDragEnter ( e ) {
      e.currentTarget.classList.add( 'drop-over' )

    }

    /**
   * On Drag Leave
   * @param {Event} e 
   */
    onDragLeave ( e ) {
      e.currentTarget.classList.remove( 'drop-over' )
    }

    /**
   * On Drag over
   * @param {Event} e 
   */
    onDragOver ( e, overData ) {
      if( e.currentTarget === this.draggedElement ) {
        return
      }
      this.dropData = overData
      this.droppedElement = e.currentTarget
    }

    /**
   * On thumbnail drag end
   * @param {Event} e 
   */
    onDragEnd ( e ) {
      this.draggedElement.classList.remove( 'drag-hide' )
      
      this.WrappedComponent = null
      this.dropData = null
    }

    getDragData () {
      return !this.dropData
        ? null
        : {
          dragData: this.dragData,
          dropData: this.dropData
        }
    }

    render () {
      return <WrappedComponent
        dragCallbacks={{
          onStartDrag:this.onStartDrag,
          onDragOver:this.onDragOver,
          onDragEnter:this.onDragEnter,
          onDragLeave: this.onDragLeave,
          onDragEnd: this.onDragEnd,
          getDragData: this.getDragData
        }}
      />
    }
  }
}


// WEBPACK FOOTER //
// ./src/hocs/withDragAndDrop.js